import { useThemeStore } from "../../state/theme";
import styles from "./ThemeToggle.module.css";

export function ThemeToggle() {
  const theme = useThemeStore((s) => s.theme);
  const toggle = useThemeStore((s) => s.toggle);

  const nextLabel = theme === "dark" ? "light" : "dark";
  const glyph = theme === "dark" ? "◐" : "◑";

  return (
    <button
      type="button"
      onClick={toggle}
      className={styles.toggle}
      aria-label={`switch to ${nextLabel} theme`}
      title={`switch to ${nextLabel}`}
    >
      <span className={styles.glyph} aria-hidden>
        {glyph}
      </span>
      <span className={styles.label}>{theme}</span>
    </button>
  );
}
